import { ApolloClient } from 'apollo-client';
import {
  validateAmount,
  validateEmail,
} from '../../../../util/form-validation';
import { convertValidationRules } from '../../../../hooks/useFormState';
import { PaymentProfileInfo } from '../../../paymentus/types';

export type Model = {
  // this must match the names of the form field
  amount: string;
  paymentProfile?: PaymentProfileInfo;
  guestEmail?: string;
};

type AdditionalContext = {
  apolloClient: ApolloClient<any>;
  t: (key: string) => string;
  maximumAmount?: number;
};
export default convertValidationRules<Model, AdditionalContext>(context => ({
  amount: amount => {
      const unFormattedAmount = Boolean(amount)
        ? amount
            .toString()
            .replace('$', '')
            .replace(',', '')
        : '';

      const validation = validateAmount(amount);

      if (validation) {
        return validation;
      }

      
      if (
        context.maximumAmount &&
        Number(unFormattedAmount) > Number(context.maximumAmount)
      ) {
        return context.t('PAYMENT_AMT_MAX_ERROR');
      }

      return null;
    
  },
  guestEmail: email => {
    if (!email) {
      return context.t('EMAIL_REQUIRED');
    }
    const validation = validateEmail(email);
    if (validation) {
      return validation;
    }
    return null;
  }

}));

